import React from 'react';
import { SummaryDashboard } from 'fitbeat.react-native-components';
import { GridLayoutWithRightContent } from './Layouts/GridLayoutWithRightContent';

export function SummaryDashboardContainer(props) {
  return (
    <GridLayoutWithRightContent {...props}>
      <SummaryDashboard {...props} />
    </GridLayoutWithRightContent>
  );
}
